import React, { useEffect, useState } from "react"
import AeroplaneIcn from "../../../../../assets/avia/search/aeroplane.svg"
import PreloaderIcn from "../../../../../assets/avia/search/preloader.svg"
import TrAeroplaneIcn from "../../../../../assets/avia/search/tr-plane.svg"
import { motion, useMotionValue, useTransform, animate } from "framer-motion"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { selectThemeName } from "../../../../../app/reducers/commonSlice"
import { cn } from "../../../../../lib"

const PLANE_IMAGES = {
  default: AeroplaneIcn,
  novatravel: TrAeroplaneIcn,
}

const PlanePreloader = () => {
  const { t } = useTranslation()

  const progress = useMotionValue(0)

  // selectors
  const themeName = useSelector(selectThemeName)

  useEffect(() => {
    const controls = animate(progress, 100, {
      duration: 6,
      ease: "linear",
      repeat: Infinity,
      repeatType: "loop",
    })

    return controls.stop
  }, [])

  const width = useTransform(progress, (v) => `${v}%`)
  const left = useTransform(progress, (v) => `${v}%`)

  return (
    <div className="w-full">
      <div className="relative">
        {/* Header */}
        <div className="flex items-center gap-3 mb-1">
          <motion.img
            src={PreloaderIcn}
            alt=""
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
          />
          <span className="text-text-main font-medium text-[24px]">
            {t("admin.tickets_search")}
          </span>
        </div>

        {/* Progress bar */}
        <div className="relative h-4 border-[1px] border-second-success rounded-full overflow-visible">
          <motion.div
            className="absolute top-0 left-0 h-full bg-second-success rounded-full"
            style={{ width }}
          />

          <motion.div className="absolute top-1/2 -translate-y-1/2" style={{ left }}>
            <motion.div
              className={cn("relative", themeName === "default" && "-ml-3")}
              animate={{ y: [0, -3, 0] }}
              transition={{ repeat: Infinity, duration: 0.8 }}
            >
              <img src={PLANE_IMAGES[themeName] || AeroplaneIcn} alt="plane" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default PlanePreloader
